import styled from "styled-components"

import { ReactComponent as IconClose } from "assets/svg/icon-close.svg"

import { PriorityBadge, type PriorityBadgeVariant } from "../PriorityBadge"

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 24px;
  flex-shrink: 0;
`

const SNTitle = styled.h2`
  font-size: 20px;
  font-weight: 500;
  color: #0f172a;
  margin: 0;
`

const HeaderSpacer = styled.div`
  flex: 1;
`

const HeaderRightActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

const FullReportLink = styled.button`
  font-size: 14px;
  font-weight: 500;
  color: #2db2c8;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  white-space: nowrap;
  line-height: 1;

  &:hover {
    text-decoration: underline;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  color: #0f172a;

  svg {
    width: 20px;
    height: 20px;
  }

  &:hover {
    opacity: 0.7;
  }
`

interface Props {
  sn: string
  priority: string
  priorityVariant: PriorityBadgeVariant
  isFullReportDisabled: boolean
  onFullReport: () => void
  onClose: () => void
}

export function DrawerHeader({ sn, priority, priorityVariant, isFullReportDisabled, onFullReport, onClose }: Props) {
  return (
    <Header>
      <SNTitle>S/N {sn}</SNTitle>
      <PriorityBadge variant={priorityVariant}>{priority}</PriorityBadge>
      <HeaderSpacer />
      <HeaderRightActions>
        <FullReportLink type="button" onClick={onFullReport} disabled={isFullReportDisabled}>
          Full Report
        </FullReportLink>
        <CloseButton type="button" onClick={onClose} aria-label="Close">
          <IconClose />
        </CloseButton>
      </HeaderRightActions>
    </Header>
  )
}
